import { userConstants } from '../_constants';

const initialStatus =  {
  successAction: false,
  items : [],
  total: 0,
  item : null,
  loading : false,
  error : null,

};

export function users(state = initialStatus, action) {

  
  switch (action.type) {
    case userConstants.KICK_REQUEST:
      return {
        ...state,
        successAction: false,
        doingAction: true,
        actionError: false,
        actionErrorMsg: null,

      };

    case userConstants.KICK_SUCCESS:
      const key = state.items.findIndex(item => item.id === action.user.id);
      let ii = state.items;
      
      if (key in ii) {
        ii.splice(key, 1, action.user);
      } else {
        ii.push(action.user);
      }

      return {
        ...state,
        successAction: true,
        doingAction: false,
        actionError: false,
        actionErrorMsg: null,
        items: ii,
      };
      break;

    case userConstants.KICK_FAILURE:
        return {
          ...state,
          successAction: false,
          doingAction: false,
          actionError: true,
          actionErrorMsg: action.error,


        };



    case userConstants.GETALL_REQUEST:
      return {
        ...state,
        loading: true
      };
    case userConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.users,
        total: action.meta.total,

        loading: false
      };
    case userConstants.GETALL_FAILURE:
      return { 
        ...state,
        error: action.error,
        loading: false
      };
    case userConstants.GETONE_REQUEST:
      return {
        ...state,
        loading: true
      };
    case userConstants.GETONE_SUCCESS:
      return {
        ...state,
        item: action.user,
        loading: false
      };
    case userConstants.GETONE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    case userConstants.DELETE_REQUEST:
      // add 'deleting:true' property to user being deleted
      return {
        ...state,
        items: state.items.map(user =>
          user.id === action.id
            ? { ...user, deleting: true }
            : user
        )
      };
    case userConstants.DELETE_SUCCESS:
      // remove deleted user from state
      return {
        ...state,
        items: state.items.filter(user => user.id !== action.id)
      };
    case userConstants.DELETE_FAILURE:
      // remove 'deleting:true' property and add 'deleteError:[error]' property to user 
      return {
        ...state,
        items: state.items.map(user => {
          if (user.id === action.id) {
            // make copy of user without 'deleting:true' property
            const { deleting, ...userCopy } = user;
            // return copy of user with 'deleteError:[error]' property
            return { ...userCopy, deleteError: action.error };
          }

          return user;
        })
      };
    default:
      return state;
  }
}